import React from 'react';
import { useQuery } from '@common/hooks';
import { BillingStats } from './billing-stats';
import {
  WorksBillingStatsQuery,
  WorksBillingStatsQueryResponse,
} from '@pay-bill/graphql';

export const BillingPageStats = () => {
  const { data: billingInfo } = useQuery<WorksBillingStatsQueryResponse>(
    WorksBillingStatsQuery
  );

  return <BillingStats data={billingInfo?.stats} />;
};
